import { z } from 'zod';

import { DeclarationCustomsFlowType } from '@e-origin/shared';

import { DiscrepancySchema } from './TransitCustomsStateSchema';
import { TransitGeneralInfoSchema } from './TransitGeneralInfoSchema';
import { optionalBoolean, optionalDate, optionalNumber, optionalString, TransitCustomsOfficeSchema } from './utils';

export const TransitListItemSchema = z.object({
  _id: z.any(),
  name: z.string(),
  counter: optionalNumber(),
  customer: z.any().optional().nullable(),
  template: z.any().optional().nullable(),
  updatedAt: optionalDate(),
  generalInfo: TransitGeneralInfoSchema.optional(),
  TransitOperation: z
    .object({
      declarationType: optionalString(),
      additionalDeclarationType: optionalString(),
      LRN: optionalString(),
      MRN: optionalString(),
      incidentFlag: optionalString(),
      simplifiedProcedure: optionalString(),
    })
    .optional(),
  HolderOfTheTransitProcedure: z.object({ name: optionalString() }).optional(),
  UnloadingRemark: z.object({ conform: optionalString() }).optional(),
  CustomsOfficeOfDeparture: z.object({ referenceNumber: optionalString() }).optional(),
  CustomsOfficeOfDestinationDeclared: z.object({ referenceNumber: optionalString() }).optional(),
  CustomsOfficeOfTransitDeclared: z.array(TransitCustomsOfficeSchema).optional(),
  Consignment: z
    .object({
      totalNumberOfPackages: optionalString(),
      grossMass: optionalString(),
      totalNumberOfSeals: optionalString(),
    })
    .optional(),
  customsState: z
    .object({
      discrepancies: z.array(DiscrepancySchema).optional(),
      flow: z.nativeEnum(DeclarationCustomsFlowType).optional().nullable(),
      sentTo: optionalString(),
      notifications: z.array(z.object({ read: optionalBoolean() })).optional(),
      recoveryNotification: z.object({ recoveryNotificationDate: optionalDate() }).optional(),
      releaseDestination: z.object({ releaseIndicator: optionalString() }).optional(),
    })
    .optional(),
});
export type TransitListItem = z.infer<typeof TransitListItemSchema>;
